import React, { useEffect, useState } from "react"

import { Form, Input, Label, Row, Col, FormFeedback } from "reactstrap"

import toast from "react-hot-toast"
import { useFormik } from "formik"
import * as Yup from "yup"
import { sanitizeIntegerInput } from "helpers/common"
import {
  useFetchBankDetailsProfileMutation,
  useUpdateBankDetailsProfileMutation,
} from "store/api/profile/profile.api"
import BankUploadAndFetch from "./bankUploadAndFetch"

const BankDetails = ({ kycData, profileData, currentStep }) => {
  const [showBankDetails, setShowBankDetails] = useState(false)
  const [updateBankDetails, { isLoading }] =
    useUpdateBankDetailsProfileMutation()
  const [bankDetails, { isLoading: isFetching }] =
    useFetchBankDetailsProfileMutation()
  const [cheque, setCheque] = useState(null)
  const {
    account_no = "",
    account_holder = "",
    ifsc = "",
    bank_name = "",
    account_type = "",
  } = profileData?.bankDetails || {}

  const validation = useFormik({
    initialValues: {
      account_no,
      account_holder,
      ifsc,
      bank_name,
      account_type,
    },
    validationSchema: Yup.object({}),
    validateOnMount: false,
    enableReinitialize: true,
    onSubmit: async (values) => {
      onFormUpdate(values)
    },
  })

  useEffect(() => {
    if (["BANK_VERIFICATION", "BANK_DETAILS"].includes(currentStep)) {
      setShowBankDetails(currentStep === "BANK_DETAILS" ? true : false)
    }
  }, [currentStep])

  const fetchBankDetails = async () => {
    try {
      const { success } = await bankDetails({
        file: cheque,
      }).unwrap()

      if (success) {
        window.location.reload()
      }
    } catch (error) {
      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }

  const onFormUpdate = async (values) => {
    try {
      const { success } = await updateBankDetails({
        ...values,
      }).unwrap()

      if (success) {
        window.location.reload()
      }
    } catch (error) {
      const data = error?.data
      if (data?.errors) {
        const { errors } = data
        validation.setErrors(errors)
      }
      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }

  return (
    <>
      <div className="bank-details-wrapper">
        <h5 className="title mb-3">Bank Details </h5>
        {/* <h5 className="title mb-3">Demat Details </h5> */}
        <p>Please add Bank Account details</p>
        <Form
          onSubmit={(e) => {
            e.preventDefault()
            validation.handleSubmit()
            return false
          }}
        >
          <Row className="mb-5">
            {!showBankDetails && (
              <>
                <Col xl={12}>
                  <Label className="col-form-label">
                    Upload Cancelled Cheque <span className="error">*</span>
                  </Label>
                  <BankUploadAndFetch
                    fieldKey={"file"}
                    setCheque={setCheque}
                    validation={validation}
                    isLoading={isFetching}
                    setShowBankDetails={() => fetchBankDetails()}
                    extensionAllowedInput={".jpg,.jpeg,.png"}
                    extensionAllowed={["image/jpeg", "image/png"]}
                    kycData={kycData}
                  />
                </Col>
              </>
            )}

            {showBankDetails && (
              <>
                <Col xl={12}>
                  <Label className="col-form-label">
                    Account Holder's Name <span className="error">*</span>
                  </Label>
                  <Input
                    name="account_holder"
                    type="text"
                    className="form-control"
                    placeholder="XXXXXXXXX"
                    // disabled={kycData?.investorsBankDetails?.account_holder}
                    value={validation?.values?.account_holder}
                    onChange={validation.handleChange}
                    invalid={
                      validation.touched.account_holder &&
                      validation.errors.account_holder
                        ? true
                        : false
                    }
                  />

                  {validation.touched.account_holder &&
                  validation.errors.account_holder ? (
                    <FormFeedback type="invalid">
                      {validation.errors.account_holder}
                    </FormFeedback>
                  ) : null}
                </Col>
                <Col xl={12}>
                  <Label className="col-form-label">
                    Account Number <span className="error">*</span>
                  </Label>
                  <Input
                    name="account_no"
                    type="text"
                    className="form-control"
                    placeholder="XXXXXXXXX"
                    // disabled={kycData?.investorsBankDetails?.account_no}
                    value={validation?.values?.account_no}
                    onChange={(e) =>
                      sanitizeIntegerInput(
                        e,
                        validation.setFieldValue,
                        "account_no"
                      )
                    }
                    invalid={
                      validation.touched.account_no &&
                      validation.errors.account_no
                        ? true
                        : false
                    }
                  />
                  {validation.touched.account_no &&
                  validation.errors.account_no ? (
                    <FormFeedback type="invalid">
                      {validation.errors.account_no}
                    </FormFeedback>
                  ) : null}
                </Col>
                <Col xl={12}>
                  <Label className="col-form-label">
                    Account Type <span className="error">*</span>
                  </Label>
                  <Input
                    name="account_type"
                    type="text"
                    className="form-control"
                    value={validation?.values?.account_type}
                    onChange={validation.handleChange}
                    invalid={
                      validation.touched.account_type &&
                      validation.errors.account_type
                        ? true
                        : false
                    }
                  />
                  {validation.touched.account_type &&
                  validation.errors.account_type ? (
                    <FormFeedback type="invalid">
                      {validation.errors.account_type}
                    </FormFeedback>
                  ) : null}
                </Col>
                <Col xl={12}>
                  <Label className="col-form-label">
                    IFSC Code <span className="error">*</span>
                  </Label>
                  <Input
                    name="ifsc"
                    type="text"
                    className="form-control"
                    // disabled={kycData?.investorsBankDetails?.ifsc}
                    value={validation?.values?.ifsc}
                    onChange={validation.handleChange}
                    invalid={
                      validation.touched.ifsc && validation.errors.ifsc
                        ? true
                        : false
                    }
                  />
                  {validation.touched.ifsc && validation.errors.ifsc ? (
                    <FormFeedback type="invalid">
                      {validation.errors.ifsc}
                    </FormFeedback>
                  ) : null}
                </Col>
                <Col xl={12}>
                  <Label className="col-form-label">
                    Bank <span className="error">*</span>
                  </Label>
                  <Input
                    name="bank_name"
                    type="text"
                    className="form-control"
                    // disabled={kycData?.investorsBankDetails?.bank_name}
                    value={validation?.values?.bank_name}
                    onChange={validation.handleChange}
                    invalid={
                      validation.touched.bank_name &&
                      validation.errors.bank_name
                        ? true
                        : false
                    }
                  />
                  {validation.touched.bank_name &&
                  validation.errors.bank_name ? (
                    <FormFeedback type="invalid">
                      {validation.errors.bank_name}
                    </FormFeedback>
                  ) : null}
                </Col>

                <Col sm={12}>
                  <div className="d-flex flex-column align-items-center mt-4">
                    <button type="submit" className="btn btn-primary w-100">
                      Save & Next
                    </button>

                    {showBankDetails && (
                      <p
                        style={{
                          fontSize: "13px",
                          marginTop: "10px",
                        }}
                        onClick={() => setShowBankDetails(false)}
                      >
                        Fetched details are not correct ? Please{" "}
                        <span
                          style={{
                            color: "#035ca1",
                            cursor: "pointer",
                            fontSize: "13px",
                            fontWeight: 500,
                            marginTop: "10px",
                          }}
                        >
                          Upload Again
                        </span>
                      </p>
                    )}
                  </div>
                </Col>
              </>
            )}
          </Row>
        </Form>
      </div>
    </>
  )
}

export default BankDetails
